import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'font-awesome/css/font-awesome.min.css';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import LandSearch from './HomeSearchLand';
import Pagination from './Pagination'; // Import the new Pagination component
import Seo from '../components/Seo';
import '../css/Landlist.css';
// import '../css/Pagination.css'
import { useLocation, useNavigate } from 'react-router-dom';
// import { HOME_CONSTANT } from '../constants/Home'
import { COMMON_CONSTANTS } from '../constants/Common'
import { AXIOS_HELPERS } from '../helpers/Axios'

const { MakeAxiosCall } = AXIOS_HELPERS
const { config: { base_url, default_map_location } } = COMMON_CONSTANTS

// const { country, states } = HOME_CONSTANT

axios.defaults.withCredentials = true;

// const base_url = process.env.REACT_APP_API_BASE_URL

// const base_url = "https://www.codingsikho.online/api/v1"

const ListLandPages = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [allLands, setAllLands] = useState(location.state?.allLands || []);
    const [totalListings, setTotalListings] = useState(location.state?.totalListings || 0);
    const [state,] = useState("")
    const [district] = useState("")

    const [currentPage, setCurrentPage] = useState(1);
    const [showPopup, setShowPopup] = useState(false); // For popup message
    const listingsPerPage = 12;


    const MapIcon = () => (
        <i className="fa fa-map-marker" style={{ fontSize: '40px', color: 'red' }}></i>
    );


    useEffect(() => {
        const fetchLands = async () => {
            try {
                const options = {
                    url: `${base_url}/getlands`,
                    params: { page: currentPage, length: listingsPerPage, state, district },
                    method: "GET",
                    maxBodyLength: Infinity
                }
                // const response = await axios.get(`${base_url}/getlands`, {
                //     params: { page: currentPage, length: listingsPerPage, state, district },
                // });
                const response = await MakeAxiosCall(options)

                // console.log("Response --------->",response)
                if (response?.data) {
                    setAllLands(response?.data?.data?.data);
                    setTotalListings(response?.data?.data?.totalListings || 0);
                }
            } catch (error) {
                console.log('Error fetching lands list:', error);
                if (error?.response?.status === 401) {
                    setShowPopup(true); // Show popup message
                }
            }
        };

        fetchLands();
    }, [currentPage, state, district]);




    const handlePopupClose = () => {
        setShowPopup(false);
        // navigate('/login'); // Redirect to login page
    };
    const handleLandDetails = (landId) => {
        // console.log('event==========', landId)
        const landDetails = allLands?.find((eachLand) => eachLand.landId === landId)
        // console.log('land details', landDetails)
        if (landDetails) {

            navigate(`/land-details/:${landId}`, { state: { landDetails } })
        }
    }

    const totalPages = Math.ceil(totalListings / listingsPerPage);


    return (
        <>
            <Seo
                title={` Land in ${district}, ${state} | KhetBazaar`}
                description={`Explore  land listings available in ${district}, ${state}.`}
                canonical={`https://khetbazaar.in/${state}/${district}`}
            />

            <div className='listland-main'>

                <NavbarComponent />
                <div className="search-container">
                    <LandSearch setAllLandList={setAllLands} filteredListing ={setTotalListings} />
                    {/* <h2>Search Your Dream Land</h2>
                {/* <h2>Search your dream Land</h2> */}
                    {/* <div className="search-bar">
                    <select className="search-dropdown" onChange={(e) => setLandType(e.target.value)} value={landType}>
                        <option value="" disabled>Select Land Type</option>
                        <option value="agriculture">Agriculture</option>
                        <option value="residential">Residential</option>
                        <option value="commercial">Commercial</option>
                    </select>
                    <select className="search-dropdown" onChange={(e) => setState(e.target.value)} value={state} required >
                        <option value="" disabled>Select State</option>
                        {country?.india?.map((eachState) => (
                            <option value={eachState} >{eachState}</option>

                        ))}
                    </select>
                    <select className="search-dropdown" onChange={(e) => setDistrict(e.target.value)} value={district}>
                        <option value="" disabled >Select District</option>
                        {state && states[state]?.length > 0 && states[state].map((eachDistrict) => (
                            <option value={eachDistrict}>{eachDistrict}</option>

                        ))}

                    </select>
                    <button className="search-button" disabled={!state} onClick={handleSearch}> Search Land</button>
                </div> */}
                </div>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalListings={totalListings}
                    onPageChange={(page) => setCurrentPage(page)}
                />

                {showPopup && (
                    <div className="popup">
                        <div className="popup-content">
                            <p>Session has expired. Please login again.</p>
                            <button onClick={handlePopupClose}>OK</button>
                        </div>
                    </div>
                )}
                <div className="land-container">
                    {allLands.length > 0 ? (
                        allLands.map((eachLand, index) => (

                            <div className="eachLandDock" key={index} onClick={() => handleLandDetails(eachLand.landId)}>
                                <img
                                    src={eachLand.imageUrl}
                                    alt={`${eachLand.landType || 'Land'} land in ${eachLand.state || 'N/A'}`}
                                />
                                <div className="land-location">
                                    <a href={eachLand.mapUrl || default_map_location} target="_blank" rel="noopener noreferrer">
                                        <span>{MapIcon()}</span> View on Map
                                    </a>
                                </div>
                                <div>
                                    <p>{eachLand.state}, {eachLand.district}</p>
                                    <p>Type: {eachLand.transactionType}</p>
                                    {/* <p>Land Type: {eachLand.landType}</p> */}
                                    {/* <p>Pincode: {eachLand.pincode}</p> */}
                                    <p>Area: {eachLand.area} acre</p>
                                    {/* <p>Price: {eachLand.pricePerAcer}/lakhs per acre</p> */}
                                </div>
                            </div>
                        ))
                    ) : (
                        <h2>No Lands Available</h2>
                    )}
                </div>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalListings={totalListings}
                    onPageChange={(page) => setCurrentPage(page)}
                />
                <FooterComponent />

            </div>

        </>
    );
};

export default ListLandPages;
